import PropTypes from "prop-types"

import _ from "lodash"

import React, { useEffect, useState, useMemo, useRef} from "react"

import {
  Alert,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import { Link, Redirect, useParams  } from "react-router-dom"

import { Formik, Field, ErrorMessage, FieldArray, useFormik } from "formik"

import withRouter from "components/Common/withRouter"

import { getSession, setSession, getCurrentUser } from "helpers/AuthType/authService"

import classnames from "classnames"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import {
  applicationResetState,
  applicationStartCoSigner,
  applicationInviteCoEmail,
  applicationInviteCoSms,
} from "store/actions"

//Import SelectWithValidation
import Toastr from "components/Common/toastr"

//Global Functions
import {
  findElementPositionById,
  regexp,
  showPreloader,
  hidePreloader,
  formatPhoneNumber,
} from "common/global/functions.js"

import InviteCoEmailForm from "./forms/inviteCoEmailForm"
import InviteCoSmsForm from "./forms/inviteCoSmsForm"
import { getInviteCoEmailSchema, getInviteCoSmsSchema } from "common/validation-schema"

const AddCosigner = props => {
  //meta title
  document.title = "Application Complete | Equity Sales Finance, INC."

  const dispatch = useDispatch()

  const params =  useParams();

  let {
    app,
    merchant : {name : merchant_name},
    pagetracker,
  } = getSession();

  let {url_identifier} = app, smsMaxInviteCounter=2;

  const applicantType = props.state.applicantType      

  const onPreviousBtnClick = path => {
    dispatch(applicationResetState(path, props.router.navigate))
  }

  const [activeTab, setactiveTab] = useState(4)
  const [exit, setExit] = useState(false)
  const [cosignerModal, setCosignerModal] = useState(false)
  const [inviteCoEmailModal, setInviteCoEmailModal] = useState(false)
  const [inviteCoSmsModal, setInviteCoSmsModal] = useState(false)
  const [loadingActivated, setLoadingActivated] = useState(false)

  const [toast, setToast] = useState(false);
  const [toastType, setToastType] = useState(false);
  const [toastMessage, setToastMessage] = useState(false);
  const [toastTitle, setToastTitle] = useState(false);
  const [toastOptions, setToastOptions] = useState(false);

  const inviteCoEmailSchema = getInviteCoEmailSchema({url_identifier , firstname : '', lastname : '', email : ''})
  const inviteCoEmailFormRef = useRef()

  const inviteCoSmsSchema = getInviteCoSmsSchema({url_identifier , firstname : '', lastname : '', cellphone : ''})
  const inviteCoSmsFormRef = useRef()

  const selectApplicationState = state => state.application
  const ApplicationProperties = createSelector(
    selectApplicationState,
    application => ({
      error: application.error,
      loading: application.loading,
      response: application.response,
    })
  )

  const { error,  loading, response, } = useSelector(ApplicationProperties)
  
  // Close Window
  const handleExit = async (e) => {
    props.router.navigate("/logout")
  }

  const toggleInviteCoEmailModal = () => {
    dispatch(applicationResetState(null, props.router.navigate))
    setInviteCoEmailModal(!inviteCoEmailModal)
  }  

  const toggleInviteCoSmsModal = () => {
    dispatch(applicationResetState(null, props.router.navigate))
    setInviteCoSmsModal(!inviteCoSmsModal)
  }
  
  // Open Consigner Modal
  const toggleCosignerModal = async (e) => {
    dispatch(applicationResetState(null, props.router.navigate))
    setCosignerModal(!cosignerModal)
  }
  
  // start application
  const handleStartCosigner = async (e) => {
    dispatch(applicationStartCoSigner(applicantType, {url_identifier}, props.router.navigate))
  }
  
  // send email link to co-signer
  const handleInviteCoEmailFormSubmit = async (e) => {
    inviteCoEmailFormRef.current.handleSubmit();
  }
  
  // send sms link to co-signer
  const handleInviteCoSmsFormSubmit = async (e) => {
    inviteCoSmsFormRef.current.handleSubmit();
  }

  const showToast = (toast) => {
    
    setToastType(toast.type ? toast.type : "success");
    setToastTitle(toast.title);
    setToastMessage(toast.message)
    if(toast.options)
    setToastOptions(toast.options)
  }
  //showToaster();
  useEffect(() => {
    
    if (error) {
      try {
        window.scroll({top: 0,left: 0,behavior: "smooth",})
      } catch (error) {
        window.scrollTo(0, 0)
      }
    }
  }, [error])

  useEffect(() => {
    if(!error && loading){
      setLoadingActivated(true)
    }else if(!error && !loading && loadingActivated){

      if(inviteCoSmsModal){
        showToast({title : "Invite sms delivered", message : "recipient invitesms delivered"})
        setToast(true);
        
      }else if(inviteCoEmailModal){
        showToast({title : "Email invite delivered", message : "recipient email invite delivered"})
        setToast(true);
      }
      setCosignerModal(false)
      setInviteCoEmailModal(false)
      setInviteCoSmsModal(false)
      setLoadingActivated(false)
    }else if(!loadingActivated){
      setToast(false);
    }
  }, [error, loading, loadingActivated])

  return (
    <React.Fragment>
      {toast && (
        <Toastr
        toastType={toastType}
        message={toastMessage}
        title={toastTitle}  
        options={toastOptions}      
        />
      )}
      
    <Modal
      isOpen={inviteCoSmsModal}
      backdrop={"static"}
      id="staticBackdrop"
      size="lg"
      role="dialog"
      autoFocus={true}
    >
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="staticBackdropLabel">
          Invite Co-Signer By Sms
        </h5>
        <button type="button" className="btn-close" onClick={toggleInviteCoSmsModal} aria-label="Close"></button>
      </div>
      <ModalBody>
        {error && <Row><Col lg="12"><Alert color="danger">{error}</Alert></Col></Row>}
        <Formik
          enableReinitialize={true}
          innerRef={inviteCoSmsFormRef}
          initialValues={
            inviteCoSmsSchema.initialValues
          }
          validationSchema={
            inviteCoSmsSchema.validationSchema
          }
          onSubmit={async values => {
            try {
              dispatch(applicationInviteCoSms(applicantType, values, props.router.navigate))
            } catch (error) {
              console.log({ error })
            }
          }}
          component={InviteCoSmsForm}
        />
      </ModalBody>
      <ModalFooter>
        <Button 
          type="button"
          className={loading ? "btn btn-light disabled" : "btn btn-light"}
          onClick={toggleInviteCoSmsModal}
        >
          Cancel
        </Button>
        <Button 
          type="button" 
          color="success"
          className={loading ? "btn btn-primary disabled" : "btn btn-primary"}
          onClick={event => {
            handleInviteCoSmsFormSubmit(event)
          }}
        >
          {loading ? (
            <>
              <Spinner size="sm">Loading...</Spinner>
              <span> sending</span>
            </>
          ) : (
            <>
              <i className="bx bx-message-rounded-dots align-middle me-1 font-size-16"></i>{"   Invite Co-Signer By Sms"}
            </>
          )}
        </Button>
      </ModalFooter>
    </div>
  </Modal>

      <Modal
        isOpen={inviteCoEmailModal}
        backdrop={"static"}
        id="staticBackdrop"
        size="lg"
        role="dialog"
        autoFocus={true}
      >
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="staticBackdropLabel">
            Invite Co-Signer By Email
          </h5>
          <button type="button" className="btn-close" onClick={toggleInviteCoEmailModal} aria-label="Close"></button>
        </div>
        <ModalBody>
          {error && <Row><Col lg="12"><Alert color="danger">{error}</Alert></Col></Row>}
          <Formik
            enableReinitialize={true}
            innerRef={inviteCoEmailFormRef}
            initialValues={
              inviteCoEmailSchema.initialValues
            }
            validationSchema={
              inviteCoEmailSchema.validationSchema
            }
            onSubmit={async values => {
              try {
                dispatch(applicationInviteCoEmail(applicantType, values, props.router.navigate))
              } catch (error) {
                console.log({ error })
              }
            }}
            component={InviteCoEmailForm}
          />
        </ModalBody>
        <ModalFooter>
          <Button 
            type="button"
            className={loading ? "btn btn-light disabled" : "btn btn-light"}
            onClick={toggleInviteCoEmailModal}
          >
            Cancel
          </Button>
          <Button 
            type="button" 
            color="pink"
            className={loading ? "btn btn-primary disabled" : "btn btn-primary"}
            onClick={event => {
              handleInviteCoEmailFormSubmit(event)
            }}
          >
            {loading ? (
              <>
                <Spinner size="sm">Loading...</Spinner>
                <span> sending</span>
              </>
            ) : (
              <>
                <i className="bx bxs-share-alt align-middle me-1 font-size-16"></i>{"   Invite Co-signer By Email"}
              </>
            )}
          </Button>
        </ModalFooter>
      </div>
    </Modal>

    {/* Exit Fill Out Application Modal*/}
    <Modal
        isOpen={cosignerModal}
        backdrop={"static"}
        id="staticBackdrop"
      >
        <div className="modal-header">
          <h5 className="modal-title" id="staticBackdropLabel">
          Co-Signer Application
          </h5>
          <button type="button" className="btn-close"
          onClick={() => {
            setCosignerModal(!cosignerModal);
          }} aria-label="Close"></button>
        </div>
        <div className="modal-body">
          <p>
            By clicking "Start" you will begin the co-signer application
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-light"
            onClick={(e) => { 
                e.preventDefault();
                setCosignerModal(!cosignerModal);
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={(e) => { 
                e.preventDefault();
                setCosignerModal(!cosignerModal);
                handleStartCosigner(e);
            }}
          >
            Start Co-Signer Application
          </button>
        </div>
      </Modal>
      {/* End Fill Out Application Modal */}

        {/* Exit Application Modal*/}
        <Modal
            isOpen={exit}
            backdrop={"static"}
            id="staticBackdrop"
          >
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Exit Application
              </h5>
              <button type="button" className="btn-close"
              onClick={() => {
                setExit(!exit);
              }} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p>
                By clicking "Exit" you will exit this application and redirected to exit page
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light"
                onClick={(e) => { 
                    e.preventDefault();
                    setExit(!exit);
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => { 
                    e.preventDefault();
                    setExit(!exit);
                    handleExit(e);
                }}
              >
                Exit
              </button>
            </div>
          </Modal>
          {/* End Exit Application Modal */}

      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={
              applicantType == "coapplicant"
                ? "Co-Signer"
                : "Applicant"
            }
            breadcrumbItem={"Add Co Signer"}
          />
          {error ? <Alert color="danger">{error}</Alert> : null}
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                
                  {/* <CardTitle className="mb-4">Add Co-Signer</CardTitle> */}
                  <div className="wizard clearfix">
                    
                    <div className="content clearfix">

              {applicantType != "coapplicant" && (<>
                        <h4 className="mt-5 mb-4">
                            <i 
                                className="bx bxs-user-plus align-middle me-1 large-icon" 
                                style={{ fontSize: "24px" }}
                            >
                            </i> 
                            {"  "}Co-Signer                           
                        </h4>
                        
                        <p className="text">Fill out or invite a co-signer</p>
                            
                        <div className="hstack gap-2">
                            <Link to="#!" className="btn btn-soft-primary" onClick={e => {
                                e.preventDefault();
                                toggleCosignerModal(true)
                            }}>
                                <i className="bx bx-window-open align-middle me-1"></i> 
                                {" "}Fill Out Co-Signer Application 
                            </Link>
                            <Link to="#!" className="btn btn-soft-pink" onClick={e => {
                                e.preventDefault();
                                toggleInviteCoEmailModal(true)
                            }}>
                                <i className="bx bxs-share-alt align-middle me-1"></i> 
                                {" "}Invite Co-Signer By Email
                            </Link>
                            <Link 
                              to="#!" 
                              className={
                                _.has(app,'invite_co_sms_counter') &&  (app.invite_co_sms_counter > smsMaxInviteCounter)
                                ? "btn btn-soft-danger disabled" 
                                : "btn btn-soft-success"
                              }
                              onClick={e => {                                
                                  e.preventDefault();
                                  toggleInviteCoSmsModal(true)
                              }}
                            >
                              {_.has(app,'invite_co_sms_counter') &&  (app.invite_co_sms_counter > smsMaxInviteCounter)
                              ? (<><i className="bx bx-error-alt align-middle me-1"></i><span>Exceeded Sms Requests</span></>)
                              : (<><i className="bx bx-message-rounded-dots align-middle me-1"></i><span>Invite Co-Signer By Sms</span></>)
                              }
                            </Link>
                        </div>
 </>)}                      
                    </div>
                    <div className="actions clearfix">
                      <ul>
                        <li className={loading ? "next disabled" : "next"}>
                          <Link
                            to={"#"}
                            onClick={e => {
                              e.preventDefault()
                              setExit(true);
                            }}
                          >
                            {loading ? (
                              <>
                                <Spinner size="sm">Loading...</Spinner>
                                <span>Loading</span>
                              </>
                            ) : (
                              "Exit Application"
                            )}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(AddCosigner)

AddCosigner.propTypes = {
  history: PropTypes.object,
}
